import { z } from 'zod';
import { platformRoleSchema } from './organizations.js';
// --- Gebruikers (D-034: herstellink zonder e-mail) ------------------------------
export const platformUserListQuerySchema = z.object({
    q: z.string().trim().max(100).optional(),
});
export const platformUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    platformRoles: z.array(platformRoleSchema),
    clubCount: z.number().int(),
    createdAt: z.string(),
});
export const platformUsersResponseSchema = z.object({ users: z.array(platformUserSchema) });
export const passwordResetLinkResponseSchema = z.object({
    /** Eenmalig; alleen in dit antwoord, nooit gelogd. */
    url: z.string(),
    expiresAt: z.string(),
});
/** Nieuw wachtwoord via herstellink; zelfde grenzen als registreren. */
export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 128;
// --- Systeemstatus (S6) ----------------------------------------------------------
export const checkStatusSchema = z.enum(['ok', 'warning', 'fail']);
export const systemCheckSchema = z.object({
    key: z.string(),
    label: z.string(),
    status: checkStatusSchema,
    /** Nederlandse uitleg, bijv. "3 wachtend, oudste 2 min". */
    detail: z.string(),
});
export const systemStatusSchema = z.object({
    status: checkStatusSchema,
    checkedAt: z.string(),
    checks: z.array(systemCheckSchema),
});
//# sourceMappingURL=platform.js.map